import React, { useState } from 'react';
import {
  Row, Col, Form, FormGroup, Label,
  ModalHeader, Modal, ModalBody,
  ModalFooter, Button, Input, FormText
} from 'reactstrap';
import moment from 'moment';

import Loading from './Loading';
import ErrorBar from './ErrorBar';

function DownloadConfigModal({
  download, isOpen, loading, objectName, toggle, createdDTS
}) {
  const [ errors, setErrors ] = useState(false);
  const [ type, setType ] = useState(false);
  const [ date, setDate ] = useState(false);
  const [ time, setTime ] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();

    let datetimeParam = null;
    if (type === 'DATES') {
      datetimeParam = moment(`${date} ${time}`).utc().format('YYYY-MM-DD HH:mm');
    }

    if (moment(datetimeParam).isBefore(createdDTS)) {
      setErrors({
        date: 'Machine didn\'t exist at this date & time',
        time: 'Machine didn\'t exist at this date & time'
      });
    } else {
      download(datetimeParam);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      unmountOnClose
      className='modal-primary modal modal-dialog-centered'
    >
      <div>
        <ModalHeader>{`Download ${objectName}`}</ModalHeader>
        {loading && <Loading />}
        {!loading && (
          <Form
            onSubmit={onSubmit}
            encType='multipart/form-data'
            className='form-horizontal'
          >
            <ModalBody>
              <Row>
                <Col>
                  {loading && <Loading />}
                  <FormGroup row>
                    <Col>
                      <Label style={{ fontWeight: 'bold' }}>
                        {`Pick the date and time of the ${objectName}`}
                      </Label>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col md='4'>
                      <Label htmlFor='select'>Download type</Label>
                    </Col>
                    <Col xs='12' md='8'>
                      <Input
                        type='select'
                        name='type'
                        id='type'
                        value={type}
                        onChange={(e) => setType(e?.target?.value)}
                        required
                      >
                        <option value=''>Please select</option>
                        <option value='CURRENT'>Current config</option>
                        <option value='DATES'>Specify dates</option>
                      </Input>
                      <ErrorBar fieldName='type' />
                    </Col>
                  </FormGroup>
                  {type === 'DATES' && (
                    <>
                      <FormGroup row>
                        <Col md='4'>
                          <Label>Date</Label>
                        </Col>
                        <Col xs='12' md='8'>
                          <Input
                            type='date'
                            id='date'
                            name='date'
                            placeholder='Date'
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                            required
                          />
                          <ErrorBar fieldName='date' />
                          <div>
                            {errors && <FormText color='danger'>{errors.date}</FormText>}
                          </div>
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Col md='4'>
                          <Label>Time</Label>
                        </Col>
                        <Col xs='12' md='8'>
                          <Input
                            type='time'
                            id='time'
                            name='time'
                            placeholder='Time'
                            value={time}
                            onChange={(e) => setTime(e?.target?.value)}
                            required
                          />
                          <ErrorBar fieldName='time' />
                          <div>
                            {errors && <FormText color='danger'>{errors.time}</FormText>}
                          </div>
                        </Col>
                      </FormGroup>
                    </>
                  )}
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button type='reset' color='danger' onClick={toggle}>
                <i className='fa fa-ban' />
                {' Close'}
              </Button>
              <Button type='submit' color='primary'>
                <i className='fa fa-download' />
                {' Download'}
              </Button>
            </ModalFooter>
          </Form>
        )}
      </div>
    </Modal>
  );
}

export default DownloadConfigModal;
